import gql from 'graphql-tag'

export default (campaignId, { name, countryId }) => {
	return {
		mutation: gql`
			mutation updateSingleCampaign(
				$campaign_id: bigint!
				$name: String!
				$country_id: bigint!
			) {
				update_conf_campaigns_by_pk(
					pk_columns: { id: $campaign_id }
					_set: { name: $name, country_id: $country_id }
				) {
					name
					country_id
				}
			}
		`,
		variables: { campaign_id: campaignId, name, country_id: countryId }
	}
}
